:host.max-size,
.max-size .screen-container {
  min-width: 100% !important;
  max-width: 100% !important;
  min-height: 100% !important;
  width: 100%;
  height: 100%;
}

.max-size .content-area {
  max-width: 600px;
}
